'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

function _interopNamespaceDefault(e) {
	var n = Object.create(null);
	if (e) {
		Object.keys(e).forEach(function (k) {
			if (k !== 'default') {
				var d = Object.getOwnPropertyDescriptor(e, k);
				Object.defineProperty(n, k, d.get ? d : {
					enumerable: true,
					get: function () { return e[k]; }
				});
			}
		});
	}
	n.default = e;
	return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

const SizeContext = React__namespace.createContext(undefined);
const SizeContextProvider = ({ children, size }) => (React__namespace.createElement(SizeContext.Consumer, null, (originSize) => React__namespace.createElement(SizeContext.Provider, { value: size || originSize }, children)));

exports.SizeContextProvider = SizeContextProvider;
exports.default = SizeContext;
//# sourceMappingURL=SizeContext.js.map
